module.exports = __webpack_public_path__ + "images/unit-icons/10x30-storage.svg";